import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const colorMap: Record<string, string> = {
  amber: 'bg-amber-100 text-amber-700',
  green: 'bg-emerald-100 text-emerald-700',
  rose: 'bg-rose-100 text-rose-700',
  orange: 'bg-orange-100 text-orange-700',
  yellow: 'bg-yellow-100 text-yellow-700',
  purple: 'bg-fuchsia-100 text-fuchsia-700',
};

export default function CategoriesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100/50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            探索音频分类
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto">
            六大分类，覆盖最受欢迎的 ASMR 场景，总有一种声音适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200/50 transition-all"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              </div>

              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className={`w-9 h-9 flex items-center justify-center rounded-full ${colorMap[cat.color] || 'bg-secondary-100 text-secondary-700'}`}>
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <h3 className="text-lg font-heading font-semibold text-foreground-900">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  {cat.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">
                    {cat.articleCount} 个音频内容
                  </span>
                  <span className="flex items-center gap-1 text-sm text-primary-600 font-medium group-hover:gap-2 transition-all">
                    浏览分类
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}